import { SharedAppConstants } from '@tock/shared-app-constants';
import { UserConsentLevel } from '@tock/shared/utils/cookieConsentUtils';

interface State {
  consentLevel: UserConsentLevel[];
  googleAnalyticsScriptsLoaded: boolean;
  amplitudeScriptsLoaded: boolean;
}

const initialState: State = {
  consentLevel: [UserConsentLevel.REQUIRED],
  googleAnalyticsScriptsLoaded: false,
  amplitudeScriptsLoaded: false,
};

export default function reducer(state: State = initialState, action: BaseTockAction): State {
  const { type, payload } = action;

  switch (type) {
    case SharedAppConstants.COOKIE_CONSENT_LEVEL_UPDATE: {
      return {
        ...state,
        consentLevel: payload,
      };
    }
    case SharedAppConstants.SCRIPT_LOAD_UPDATE: {
      return {
        ...state,
        googleAnalyticsScriptsLoaded: payload,
        amplitudeScriptsLoaded: payload,
      };
    }
    default:
      return state;
  }
}
